meedy.factory('meedy.resourceModel', ['$rootScope', 'applicationModel', 'meedy.baseModel', 'meedy.resourceService',
    function ($rootScope, applicationModel, baseModel, resourceService) {

        function ResourceModel() {

            this.delete = function (idResource) {
                resourceService.delete(idResource).then(
                    function (resources) {
                        $rootScope.$broadcast(Event.MEEDY.RESOURCE.DELETE.SUCCESS, resources);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.RESOURCE.DELETE.ERROR, error);
                    }
                )
            };

            this.getDataPage = function (criteria) {
                resourceService.getDataPage(criteria).then(
                    function (resources) {
                        $rootScope.$broadcast(Event.MEEDY.RESOURCE.GET_DATA_PAGE.SUCCESS, resources);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.RESOURCE.GET_DATA_PAGE.ERROR, error);
                    }
                )
            };

            this.save = function (resource) {
                applicationModel.actionInProgress = true;
                resourceService.save(resource).then(
                    function (resources) {
                        $rootScope.$broadcast(Event.MEEDY.RESOURCE.SAVE.SUCCESS, resources);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.RESOURCE.SAVE.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.getById = function (idResource) {
                resourceService.getById(idResource).then(
                    function (resources) {
                        $rootScope.$broadcast(Event.MEEDY.RESOURCE.GET_BY_ID.SUCCESS, resources);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.RESOURCE.GET_BY_ID.ERROR, error);
                    }
                )
            };

            this.getResourcesAvailableForLoggedUser = function () {
                resourceService.getResourcesAvailableForLoggedUser().then(
                    function (resources) {
                        $rootScope.$broadcast(Event.MEEDY.RESOURCE.GET_RESOURCES_AVAILABLE_FOR_LOGGED_USER.SUCCESS, resources);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.RESOURCE.GET_RESOURCES_AVAILABLE_FOR_LOGGED_USER.ERROR, error);
                    }
                )
            };

            this.getPricelist = function (idResource) {
                resourceService.getPricelist(idResource).then(
                    function (resourcePriceList) {
                        $rootScope.$broadcast(Event.MEEDY.RESOURCE.GET_PRICE_LIST.SUCCESS, resourcePriceList);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.RESOURCE.GET_PRICE_LIST.ERROR, error);
                    }
                )
            };
        }

        return new ResourceModel();
    }
]);
